import React, { useContext, useState, useEffect, useRef } from 'react';
import styles from './style.module.scss';
import { Grid, Paper, Button, Card, Switch, } from '@material-ui/core';
import { Details } from './constant';
import { Context as AuthContext } from '../../context/AuthContext';
import { fetchUserDetails, toggleStoreVisibility, uploadStoreBanner } from './indexApi';
import { Facebook, FileCopy, Share, Twitter } from '@material-ui/icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    TwitterIcon,
    EmailIcon,
    FacebookIcon,
    WhatsappIcon
} from "react-share";
import AlertComponent from '../../components/AlertComponent';

const ProfilePage = () => {
    const [selectedTab, setSelectedTab] = useState('Personal Details');
    const { state } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState({});
    const [storeVisibility, setStoreVisibility] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({
        msg: null,
        color: null
    })
    const [showVal, setShowVal] = useState(false);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [bannerType, setBannerType] = useState("desktop");
    const refVal = useRef()
    const fileInputRef = useRef(null);

    const errorColor = '#f44336';
    const successColor = '#4caf50';

    const loginData = state.userData;

    useEffect(() => {
        getUserDetails();
    }, []);

    useEffect(() => {
        // Clear file when banner type changes to ensure user selects appropriate file
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    }, [bannerType]);

    const getUserDetails = async () => {
        await fetchUserDetails().then((res) => {
            if (res && res.data && res.data.status === 'success') {
                setUserDetails(res.data.data);
                setStoreVisibility(res.data.data.store_visibility);
            }
            else {
                alert('Error while fetching the data. Try after sometime.')
            }
        })
    }

    const basicInfo = () => {
        return (
            <table id={styles.tableContainer}>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Name</td>
                    <td >{userDetails.name}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Mobile Number</td>
                    <td >{userDetails.phone_number}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Email Id</td>
                    <td >{userDetails.email}</td>
                </tr>
            </table>
        )
    }
    const bankInfo = () => {
        return (
            <table id={styles.tableContainer}>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Account Holder Name</td>
                    <td >{userDetails.account_holder_name}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Account Number</td>
                    <td >{userDetails.account_number}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Bank Name</td>
                    <td >{userDetails.bank_name}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">IFSC Code</td>
                    <td >{userDetails.p_ifsc ? userDetails.p_ifsc.toUpperCase() : null}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">GSTIN</td>
                    <td >{userDetails.gstin ? userDetails.gstin.toUpperCase() : null}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">PAN </td>
                    <td >{userDetails.pan ? userDetails.pan.toUpperCase() : null}</td>
                </tr>
            </table>
        )
    }
    const businessInfo = () => {
        return (
            <table id={styles.tableContainer}>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Shop Name</td>
                    <td >{userDetails.shop_name}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Listing Name</td>
                    <td >{userDetails.listing_name}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Business Type</td>
                    <td >{userDetails.store_type}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Category</td>
                    <td >{userDetails.category}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Address Line1</td>
                    <td >{userDetails.line_1}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Address Line2</td>
                    <td >{userDetails.line_2}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">Pincode</td>
                    <td >{userDetails.pincode}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">City</td>
                    <td >{userDetails.city}</td>
                </tr>
                <tr className={`${styles.tableRow}`}>
                    <td className="text-muted">State</td>
                    <td >{userDetails.state}</td>
                </tr>
            </table>
        )
    }

    const decode = (link) => {
        return  link.replace(/\s/g , "-")
    }

    const fetchStoreLink = () => {
        if (
            window.location.href.indexOf("test") > -1 ||
            window.location.href.indexOf("localhost") > -1
        ) {
            return (`https://gostor.vercel.app/store/${loginData.name}?storeId=${loginData.seller_id}`);
        }
        return (`https://gostor.com/store/${loginData.name}?storeId=${loginData.seller_id}`);
    }

    //function to show alerts
    const setAlertFnc = (msg, type, show) => {
        setShowAlert(show);
        setAlertObj({ msg: msg, color: type })
    }

    const copyToClipboard = () => {
        var range = document.createRange();
        range.selectNode(document.getElementById("copyContentInput"));
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        let msg = `Copied content to clipboard.`
        setAlertFnc(msg, successColor, true);
    }
    const shareData = `${loginData.name} is online now with Gostor. Click on this link ${fetchStoreLink()} to check our catalogue and place orders`;
   

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    //function to handle modle click
    const handleClick = e => {
        if (refVal && refVal.current && (!refVal.current.contains(e.target))) {
            setShowVal(false)
        }
    };

    const handleStoreVisibility = async (event) => {
        try {
            let payload = {
                userId: userDetails?.userId,
                store_visibility: event.target.checked,
            }
            const response = await toggleStoreVisibility(payload);
            if(response && response.data && response.data.status === "success" && response.data.msg) {
                getUserDetails();
                setAlertFnc(response.data.msg, successColor, true);
            } else {
                setAlertFnc(response.data.msg, errorColor, true);
            }
        } catch (error) {
            setAlertFnc('Unable to Update Store Settings!', errorColor, true);
        }
    }

  const validateImageDimensions = (file, expectedWidth, expectedHeight) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          if (img.width === expectedWidth && img.height === expectedHeight) {
            resolve(true);
          } else {
            reject(new Error(`Image dimensions must be ${expectedWidth}x${expectedHeight} pixels. Current dimensions: ${img.width}x${img.height} pixels.`));
          }
        };
        img.onerror = () => {
          reject(new Error("Failed to load image."));
        };
        img.src = e.target.result;
      };
      reader.onerror = () => {
        reject(new Error("Failed to read file."));
      };
      reader.readAsDataURL(file);
    });
  };

  const handleChange = async (e) => {
    const banner = e.target.files[0];
    if (!banner) return;

    if (!banner.type.startsWith("image/")) {
      setAlertFnc("Only image files allowed.", errorColor, true);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      return;
    }

    try {
      // Validate dimensions based on banner type
      const expectedDimensions = bannerType === "mobile" 
        ? { width: 360, height: 180 }
        : { width: 1920, height: 520 };
      
      await validateImageDimensions(banner, expectedDimensions.width, expectedDimensions.height);
      setFile(banner);
    } catch (error) {
      setAlertFnc(error.message, errorColor, true);
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
        setAlertFnc("Please select a banner first.", errorColor, true);
        return;
    }
    try{
        const formData = new FormData();
        formData.append("image", file);
        formData.append("type", bannerType);
        setLoading(true);
        const response = await uploadStoreBanner(formData);
           if(response && response.data && response.data.status === "success" && response.data.message) {
                getUserDetails();
                setAlertFnc(response.data.message, successColor, true);
                setFile(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            } else {
                setAlertFnc("Something went wrong.", errorColor, true);
            }
    } catch (error) {
        setAlertFnc("Something went wrong.", errorColor, true);
    } finally {
        setLoading(false);
    }
  };

    return <div className={styles.mainContainer}>
        <h5>Manage Profile</h5>
        <AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
        <Grid container spacing={1} id={styles.parentContainer}>
            <Grid item md={3}>
                <Card variant="outlined">
                    <div className="p-3">
                        <h6 className="text-muted">Your website link:</h6>
                        <div className="d-flex align-items-center justify-content-between">
                            <a style={{wordBreak: 'break-all'}} id={'copyContentInput'} className="text-dark" href={fetchStoreLink()} target="_blank" rel="noreferrer"> {decode(fetchStoreLink())} </a>
                            <div>
                                <FileCopy className="text-muted" style={{ fontSize: '1.25rem', cursor: 'pointer', textDecoration: 'none', color: '#389203' }} onClick={() => copyToClipboard()} />
                            </div>
                        </div>
                        <div className="mt-3">
                            <Button variant="outlined" color="primary">
                                <a href={fetchStoreLink()} target="_blank" style={{ textDecoration: 'none', color: '#389203' }} rel="noreferrer"> View </a>
                            </Button>
                            <span ref={refVal}>
                                <OverlayTrigger container={refVal} trigger="click" placement="top" show={showVal} overlay={
                                    <Popover id="popover-basic">
                                        <Popover.Content id={styles.popContent}>
                                            <div className={styles.popoverBody}>
                                                {/* <Facebook style={{color:'#3b5998'}}/>
                                                    <Twitter style={{color:'#00acee'}} className="ml-2"/> */}
                                                <FacebookShareButton
                                                    url={fetchStoreLink()}
                                                    quote={shareData}
                                                    separator={'\n'}
                                                    className="mr-3"
                                                    style={{ outline: 'none', border: 'none' }}
                                                >
                                                    <FacebookIcon round={true} size={36} />
                                                </FacebookShareButton>
                                                <TwitterShareButton
                                                    url={fetchStoreLink()}
                                                    title={shareData}
                                                    separator={'\n'}
                                                    className="mr-3"
                                                    style={{ outline: 'none', border: 'none' }}
                                                >
                                                    <TwitterIcon size={36} round={true} />
                                                </TwitterShareButton>
                                                <EmailShareButton
                                                    url={fetchStoreLink()}
                                                    separator={'\n'}
                                                    subject="Store Promotion"
                                                    body={shareData}
                                                    style={{ outline: 'none', border: 'none' }}
                                                >
                                                    <EmailIcon size={36} round={true} />
                                                </EmailShareButton>

                                            </div>
                                        </Popover.Content>
                                    </Popover>
                                }>
                                    <Button variant="contained" color="primary" className="ml-3" onClick={() => setShowVal(true)}>
                                        <Share className="text-white mr-2" style={{ fontSize: '1.25rem', cursor: 'pointer' }} />
                                        Share
                                    </Button>
                                </OverlayTrigger>
                            </span>
                        </div>
                    </div>
                </Card>
            </Grid>

            <Grid item md={3}>
                <Card variant="outlined" style={{height: "100%"}}>
                    <div className="p-3">
                        <div>
                            <h6 className="text-muted">Store Visibility:</h6>
                            <Switch
                                checked={storeVisibility}
                                onChange={handleStoreVisibility}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </div>
                            {storeVisibility ? 
                            "You can hide your store being listed on our platform" : 
                            "You can Enable this option so your store will be visible on our platform"}
                    </div>
                </Card>
            </Grid>

             {storeVisibility && (
                <Grid item md={3}>
                    <Card variant="outlined" style={{ height: "100%" }}>
                    <div className="p-3">
                        <div>
                        <h6 className="text-muted">Store Banner upload:</h6>

                        <label className="block mb-2">Banner Type</label>
                        <select
                            value={bannerType}
                            onChange={(e) => setBannerType(e.target.value)}
                            className="form-control mb-2"
                        >
                            <option value="mobile">Mobile</option>
                            <option value="desktop">Desktop</option>
                        </select>
                        <small className="text-muted d-block mb-3" style={{ fontSize: '0.875rem' }}>
                            Required image size: {bannerType === "mobile" ? "360 x 180 pixels" : "1920 x 520 pixels"}
                        </small>
                        </div>
                        <div className="mb-3">
                            <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            onChange={handleChange}
                        />
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button  className="p-2 text-white text-bold" style={{
                                backgroundColor: "#389203",
                                outline: "none",
                                border: "none",
                                borderRadius: "5%",
                                cursor: "pointer"
                            }} onClick={handleUpload} disabled={loading}>
                                {loading ? "Uploading..." : "Upload Banner"}
                            </button>
                        </div>
                    </div>
                    </Card>
                </Grid>
            )}
        </Grid>
           
        <Grid container spacing={3} id={styles.parentContainer}>
            <Grid item md={3}>
                <Paper >
                    {
                        Details.map((item) => {
                            return <div key={item.id} onClick={() => setSelectedTab(item.name)}>
                                <div className={`${selectedTab === item.name ? styles.activeTab : null} ${styles.divComp}`}>
                                    <h6 className="mb-1">{item.name}</h6>
                                    <small className="text-muted">{item.subText}</small>
                                </div>

                            </div>
                        })
                    }

                </Paper>
            </Grid>
            <Grid item md={9} sm={6}>
                <Paper >
                    <div id={styles.tabComponent}>
                        <div className="d-flex align-items-end justify-content-between">
                            <h6>{selectedTab}</h6>
                        </div>
                        {
                            selectedTab === 'Personal Details' ?
                                basicInfo() :
                                null
                        }
                        {
                            selectedTab === 'Business Details' ?
                                businessInfo() :
                                null
                        }
                        {
                            selectedTab === 'Bank Details' ?
                                bankInfo() :
                                null
                        }
                    </div>
                </Paper>
            </Grid>
        </Grid>
    </div>
}

export default ProfilePage;